import React from "react";
import "./resources.css";
import Footer from "../Footer";

const Changelog = () => {
  const updates = [
    {
      version: "v1.5",
      date: "June 2026",
      title: "Legal, Privacy & Compliance Pages",
      items: [
        "Added Privacy Policy page",
        "Added Terms of Service page",
        "Added Data Processing page",
        "Added Security page",
        "Added Cookies page",
        "Added cookie consent banner",
      ],
    },
    {
      version: "v1.4",
      date: "May 2026",
      title: "Inventory & Business Management Improvements",
      items: [
        "Added inventory dashboard",
        "Added item and warehouse management",
        "Added stock movement tracking",
        "Added stock-on-hand reporting",
      ],
    },
    {
      version: "v1.3",
      date: "April 2026",
      title: "Reports & Accounting Enhancements",
      items: [
        "Improved income statement",
        "Improved balance sheet",
        "Improved cash flow report",
        "Added trial balance and general ledger views",
      ],
    },
    {
      version: "v1.2",
      date: "March 2026",
      title: "Invoice & Customer Management",
      items: [
        "Improved invoice creation",
        "Added PDF invoice generation",
        "Added customer records",
        "Added payment tracking",
      ],
    },
  ];

  return (
    <div className="resource-page">
      <div className="resource-container">
        <h1>Changelog</h1>
        <p className="resource-subtitle">
          Follow major updates, improvements, and new features released on
          KostPadi.
        </p>

        <div className="changelog-list">
          {updates.map((update) => (
            <section className="changelog-card" key={update.version}>
              <div className="changelog-meta">
                <span>{update.version}</span>
                <small>{update.date}</small>
              </div>

              <h2>{update.title}</h2>

              <ul>
                {update.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Changelog;
